// This file is generated.
export var version = '1.35.1';
//# sourceMappingURL=version.js.map